import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { store } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadTenderText',
  setup(__props) {

const selectedConfigVariant = computed<ProfessionalVariantViewObject>(() => store.getters['catalog/selectedConfigVariant']);

function downloadTenderText() {
    return '/api/tendertext/tenderstring?id=' + selectedConfigVariant.value.sapId;
}

function downloadTenderTextNeutral() {
    return '/api/tendertext/tenderstringneutral?id=' + selectedConfigVariant.value.sapId;
}

function downloadTenderD81() {
    return '/api/tendertext/tenderd81?id=' + selectedConfigVariant.value.sapId;
}

function downloadTenderX81() {
    return '/api/tendertext/tenderx81?id=' + selectedConfigVariant.value.sapId;
}

return { __sfc: true,selectedConfigVariant, downloadTenderText, downloadTenderTextNeutral, downloadTenderD81, downloadTenderX81 }
}

})